import { useState } from 'react';
import { Globe, X } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';

const OPTIONS = [
  { code: 'BRL', flag: 'br', label: 'R$', cls: 'bg-red-600 hover:bg-red-700' },
  { code: 'EUR', flag: 'pt', label: '€', cls: 'bg-blue-600 hover:bg-blue-700' },
  { code: 'USD', flag: 'us', label: 'US$', cls: 'bg-emerald-600 hover:bg-emerald-700' },
];

export const CurrencyWelcomeNotice = () => {
  const { currency, setCurrency, autoDetected } = useCurrency();
  const [dismissed, setDismissed] = useState(() => !!sessionStorage.getItem('eur_notice_shown'));

  if (!autoDetected || currency === 'BRL' || dismissed) return null;

  const close = () => {
    sessionStorage.setItem('eur_notice_shown', '1');
    setDismissed(true);
  };

  const choose = (cur) => {
    setCurrency(cur);
    close();
  };

  return (
    <div className="fixed top-20 left-0 right-0 z-40 bg-blue-950/97 backdrop-blur-md border-b border-blue-500/40 shadow-lg" data-testid="eur-welcome-notice">
      <div className="container mx-auto px-4 lg:px-8 py-3 flex items-center justify-center gap-4 flex-wrap text-center">
        <div className="flex items-center gap-2">
          <Globe size={18} className="text-blue-300 shrink-0" />
          <span className="text-sm text-blue-100 font-medium">
            Escolha a moeda para ver os preços:
          </span>
        </div>
        <div className="flex items-center gap-2">
          {OPTIONS.map((opt) => (
            <button
              key={opt.code}
              type="button"
              onClick={() => choose(opt.code)}
              data-testid={`eur-notice-switch-${opt.code.toLowerCase()}`}
              className={`flex items-center gap-2 text-sm font-semibold text-white ${opt.cls} rounded-lg px-3.5 py-2 transition-colors`}
            >
              <img src={`https://flagcdn.com/32x24/${opt.flag}.png`} alt={opt.label} className="w-6 h-auto rounded-[2px]" />
              {opt.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={close}
          data-testid="eur-notice-close"
          className="text-blue-300 hover:text-white transition-colors"
          aria-label="Fechar aviso"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default CurrencyWelcomeNotice;
